import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css', '../../shared/styles/common.css'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
 
  hidePassword = false;
  hideConfirmPassword = false;
  isLoading = false;
  token: string = '';

  email: any;
  submitted = false;

  message: string = '';
  subscription: any;
  mail:any;
  password_status = "fa fa-eye-slash";
  hide = true;
  confirm_password_status = "fa fa-eye-slash";
  confirm_hide = true;
  tmail: string = '';
  tToken:any;
  isFromResetMode: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,private toastr: ToastrService, private data: DataService,
    private snackBar: MatSnackBar
  ) {
    // this.myForm = this.fb.group({
    //   password: ['', [Validators.required, Validators.minLength(8)]],
    //   confirmPassword: ['', [Validators.required]]
    // }, { validator: this.passwordMatchValidator });
  }

  myForm = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
    token: ['', Validators.required],
    ConfirmPassword: ['', Validators.required]
  }, { validator: this.checkPasswords })

  get f() { return this.myForm.controls; }

  checkPasswords(group: FormGroup) { // here we have the 'passwords' group
    let pass = group.controls['password'].value;
    let confirmPass = group.controls['ConfirmPassword'].value;

    return pass === confirmPass ? null : { notSame: true }
  }

  ngOnInit() {
    //this.token = this.route.snapshot.queryParams['token'];
    // if (!this.token) {
    //  // this.snackBar.open('Invalid reset token', 'Close', { duration: 3000 });
    //   this.router.navigate(['/login']);
    // }
    this.mail = localStorage.getItem('reemail');
    
    this.subscription = this.data.cofferIdMessage.subscribe(message => {
      this.message = message;
      console.log('message',this.message)
    });

    // if (this.message == "empty" || this.message == "") {
    //   this.router.navigate(['/forgot-password']);
    // }

    // Set focus on the last added input field
    setTimeout(() => {
      const inputs = document.querySelectorAll(`.gettk`);
      const lastInput = inputs[inputs.length - 1] as HTMLInputElement;
      if (lastInput) {
        lastInput.focus();
      }
    });

        
    // Get query params (token & email)
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      const email = params['email'];
      // console.log('token',token)
      // console.log('email',email)
      this.tToken = token;
      
      if (token) {
        this.isFromResetMode = true;
        this.myForm.patchValue({ token });
        this.myForm.get('token')?.disable(); // Disable token field if it came from password_mode='reset'
      }
      if (email) {
        this.mail = email;
      }
    });

  }

  password_icon(){
    this.password_status = "fa fa-eye";
    this.hide = !this.hide;
    
    if(this.hide){
      this.password_status = "fa fa-eye-slash"
    } else {
      this.password_status = "fa fa-eye"
      this.hide = false;
    }
  }

  confirm_password_icon(){
    this.confirm_password_status = "fa fa-eye";
    this.confirm_hide = !this.confirm_hide;
    
    if(this.confirm_hide){
      this.confirm_password_status = "fa fa-eye-slash"
    } else {
      this.confirm_password_status = "fa fa-eye"
      this.confirm_hide = false;
    }
  }

  onSubmit(token: any, password: any, confirmPassword: any) {
    // console.log('tk', token)
    // console.log('password', password)
    // console.log('confirmPassword', confirmPassword)
    // console.log('msg', this.message)
    // console.log('myForm', this.myForm.value)

    let coffer_id = localStorage.getItem('coffer_id') ?? '';
    // console.log('coffer_id', coffer_id)

    this.submitted = true;
    if (this.myForm.invalid) {
      return;
    }

    if (this.isFromResetMode === true) {
      const payload = {
        //field: 'password',
        old: this.tToken,
        new: this.myForm.value?.password
      };

      this.authService.update_password(payload).subscribe((res: any) => {
        if (res.error === true) {
          this.toastr.error(res.msg);
          return
        }
        else {
          this.toastr.success(res.msg, "Success!");
          this.router.navigate(['/login']);
        }
      },
        (error: HttpErrorResponse) => {
          // This block runs for HTTP 4xx or 5xx errors
          const errorMsg = error?.error?.msg || 'Something went wrong.';
          this.toastr.error(errorMsg);
        });
    }
    else {
      this.authService.submit_password(coffer_id, password, token).subscribe({
        next: (res: HttpResponse<any>) => {
          //console.log('rrr', res);

          if (!res.body.error) {
            this.router.navigate(['/login']);
            this.toastr.success(res.body.msg, "Success!");
          } else {
            this.toastr.error((res.body.msg || "Token is invalid/expired."), "Error!");
          }
        },
        error: (err) => {
          console.error('API Error:', err);
          this.toastr.error("Token is invalid or expired.", "Error!");
        }
      });
    }
  }

  resend_token(){
    let coffer_id = localStorage.getItem('coffer_id') ?? '';
    this.authService.resend_password_token(coffer_id).subscribe((res: HttpResponse<any>) => {
      if(res.body && res.body.error === false){
        this.toastr.success(res.body.msg);
      }
    });
  }

  private passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null : { mismatch: true };
  }

  restricttextSpace(event: any) {
		let inputValue: string = event.target.value;
		inputValue = inputValue.replace(/^\s+/, '');
		inputValue = inputValue.replace(/\s{2,}/g, ' ');
		event.target.value = inputValue;
		return;
	}

  // onSubmit(): void {
  //   if (this.resetForm.valid) {
  //     this.isLoading = true;
  //     const newPassword = this.resetForm.get('password')?.value;

  //     this.authService.resetPassword(this.token, newPassword).subscribe({
  //       next: () => {
  //         this.snackBar.open('Password reset successful! Please login with your new password.', 'Close', { duration: 5000 });
  //         this.router.navigate(['/login']);
  //       },
  //       error: (error: string) => {
  //         this.snackBar.open(error, 'Close', { duration: 3000 });
  //         this.isLoading = false;
  //       }
  //     });
  //   }
  // }
}
